import ApiService from './ApiService';

export async function apiSignIn(data) {
  return ApiService.fetchData({
    url: '/sign-in',
    method: 'post',
    data,
  });
}

export async function apiSignUp(data) {
  return ApiService.fetchData({
    url: '/sign-up',
    method: 'post',
    data,
  });
}

export async function apiSignOut(data) {
  return ApiService.fetchData({
    url: '/sign-out',
    method: 'post',
    data,
  });
}

export async function apiForgotPassword(data) {
  console.log('🟡 AuthService.apiForgotPassword - INÍCIO');
  console.log('🟡 AuthService.apiForgotPassword - data:', data);
  
  const result = await ApiService.fetchData({
    url: '/user/forget-password',
    method: 'post',
    data,
  });
  
  console.log('🟡 AuthService.apiForgotPassword - Resultado:', result);
  console.log('🟡 AuthService.apiForgotPassword - result.data:', result?.data);
  console.log('🟡 AuthService.apiForgotPassword - Retornando resultado');
  
  return result;
}

export async function apiResetPassword(data) {
  return ApiService.fetchData({
    url: '/reset-password',
    method: 'post',
    data,
  });
}
